import axios, { AxiosResponse } from 'axios';
import { v4 as uuidv4 } from 'uuid';

import config from 'jss-boilerplate/temp/config.js';
import { getAccessToken } from 'core/browserStorage';
import {
	AKAMAI_BOT_FLAG,
	X_CORRELATION_APP,
	MEMBER_EXPERIENCE_BASE,
} from 'core/constants';
import { ExpMemberData } from 'core/api/client/MemberExperienceApi';

/**
 * Fetch member details from Member API.
 * @returns {Promise<ExpMemberData>} The member details.
 */

export const useGetMemberDetails = () => {
	return axios({
		url: `${MEMBER_EXPERIENCE_BASE}/member-details`,
		method: 'GET',
		responseType: 'json',
		headers: {
			'Authorization': `Bearer ${getAccessToken()}`,
			'Accept': 'application/json',
			'Cache-Control': 'no-cache',
			'X-API-Key': config?.externalServices?.coarseGrainApiKey,
			'X-Correlation-Id': uuidv4(), // FED initiated correlationID
			'X-Correlation-App': X_CORRELATION_APP, // Link detection of request origin
		},
		withCredentials: AKAMAI_BOT_FLAG,
	})
		.then((response: AxiosResponse<ExpMemberData>) => {
			return response.data;
		})
		.catch(error => {
			console.error('Failed to fetch member details:', error);
		});
};
